import { useTranslation } from "react-i18next";
import { SceneClock as SceneClockType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import Select from "@components/forms/Select/Select";
import Switch from "@components/forms/Switch/Switch";
import { dateFormats, displayModes } from "../../../constants";
import Color from "@components/forms/Color/Color";
import Product, { ProductModelType } from "@ltypes/product";
import { useSelector } from "react-redux";

type SceneClockProps = {
    scene: SceneClockType,
    onChange: (field: string, value: string|number|boolean) => void,
};

function SceneClock(props: SceneClockProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].clock.map((index: number) => ({
                            id: index,
                            background: `clock-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            {product.model.type == ProductModelType.LEGACY ? (
                <div className="col-12 col-md-6">
                    <div className="row g-3">
                        <div className="col-12">
                            <div className="row g-0">
                                <div className="col-8">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <Switch label={t('page.scenes.data.show_seconds')} checked={props.scene.show_seconds} onChange={(checked: boolean) => props.onChange('show_seconds', Boolean(checked))}/>
                                        </div>
                                        <div className="col-12">
                                            <Switch label={t('page.scenes.data.show_date')} checked={props.scene.show_date} onChange={(checked: boolean) => props.onChange('show_date', Boolean(checked))}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <Color label={t('page.scenes.data.text_color')} value={props.scene.color1} onChange={(value: string) => props.onChange('color1', value)}/>
                                </div>
                            </div>
                        </div>
                        {props.scene.show_date && (
                            <div className="col-12">
                                <Select label={t('page.scenes.data.date_format')} value={props.scene.date_format} items={dateFormats} onChange={(value: string) => props.onChange('date_format', Number(value))}/>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="col-12 col-md-6">
                    <div className="row g-3">
                        <div className="col-12">
                            {props.scene.display_mode === 0 ? (
                                <>
                                    <Color label={t('page.scenes.data.bgcolor_1')} value={props.scene.color1} onChange={(value: string) => props.onChange('color1', value)}/>
                                    <Color label={t('page.scenes.data.textcolor_1')} value={props.scene.color2} onChange={(value: string) => props.onChange('color2', value)}/>
                                    <Color label={t('page.scenes.data.bgcolor_2')} value={props.scene.color3} onChange={(value: string) => props.onChange('color3', value)}/>
                                    <Color label={t('page.scenes.data.textcolor_2')} value={props.scene.color4} onChange={(value: string) => props.onChange('color4', value)}/>    
                                </>
                            ) : props.scene.display_mode === 1 ? (
                                <>
                                    <Color label={t('page.scenes.data.textcolor_1')} value={props.scene.color1} onChange={(value: string) => props.onChange('color1', value)}/>
                                </>
                            ) : props.scene.display_mode === 2 ? (
                                <>
                                    <Color label={t('page.scenes.data.bgcolor_1')} value={props.scene.color1} onChange={(value: string) => props.onChange('color1', value)}/>
                                    <Color label={t('page.scenes.data.textcolor_1')} value={props.scene.color2} onChange={(value: string) => props.onChange('color2', value)}/>
                                </>
                            ) : <></>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SceneClock;
